import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { nextTick as h, openBlock as E, createElementBlock as w, pushScopeId as B, popScopeId as H, createElementVNode as s, defineComponent as C, ref as m, toRefs as R, watch as b, onMounted as N, onUnmounted as O, withDirectives as V, renderSlot as u, createVNode as M, vShow as T, toDisplayString as v, createCommentVNode as g } from "vue";

function D(e, o) {
  var n = e.getBoundingClientRect();
  if (!o) return n.top >= 0 && n.bottom <= window.innerHeight;
  var t = o.getBoundingClientRect();
  return n.top >= t.top && n.bottom <= t.bottom;
}

function q(_x) {
  return _q.apply(this, arguments);
}

function _q() {
  _q = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return h();

          case 2:
            return _context3.abrupt("return", e.value instanceof HTMLElement ? e.value : e.value ? document.querySelector(e.value) : null);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _q.apply(this, arguments);
}

function y(e) {
  var o = "0px 0px ".concat(e.distance, "px 0px");
  e.top && (o = "".concat(e.distance, "px 0px 0px 0px"));
  var n = new IntersectionObserver(function (t) {
    t[0].isIntersecting && (e.firstload && e.emit(), e.firstload = !0);
  }, {
    root: e.parentEl,
    rootMargin: o
  });
  return n.observe(e.infiniteLoading.value), n;
}

var x = function x(e, o) {
  var n = e.__vccOpts || e;

  var _iterator = _createForOfIteratorHelper(o),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var t = _ref2[0];
      var c = _ref2[1];
      n[t] = c;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n;
},
    P = {},
    U = function U(e) {
  return B("data-v-d3e37633"), e = e(), H(), e;
},
    j = {
  class: "container"
},
    z = /* @__PURE__ */U(function () {
  return /* @__PURE__ */s("div", {
    class: "spinner"
  }, null, -1);
}),
    A = [z];

function F(e, o) {
  return E(), w("div", j, A);
}

var G = /* @__PURE__ */x(P, [["render", F], ["__scopeId", "data-v-d3e37633"]]),
    J = {
  class: "state-error"
},
    K = /* @__PURE__ */C({
  __name: "InfiniteLoading",
  props: {
    top: {
      type: Boolean,
      default: !1
    },
    target: {},
    distance: {
      default: 0
    },
    identifier: {},
    firstload: {
      type: Boolean,
      default: !0
    },
    slots: {}
  },
  emits: ["infinite"],
  setup: function setup(e, _ref4) {
    var o = _ref4.emit;
    var n = e;
    var t = null,
        c = 0;

    var d = m(null),
        r = m(""),
        p = n.top,
        I = n.firstload,
        S = n.distance,
        _R = R(n),
        k = _R.identifier,
        L = _R.target,
        i = {
      infiniteLoading: d,
      top: p,
      firstload: I,
      distance: S,
      parentEl: null,
      emit: function emit() {
        c = (i.parentEl || document.documentElement).scrollHeight, f.loading(), o("infinite", f);
      }
    },
        f = {
      loading: function loading() {
        r.value = "loading";
      },
      loaded: function loaded() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var l;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  r.value = "loaded";
                  l = i.parentEl || document.documentElement;
                  _context.next = 4;
                  return h();

                case 4:
                  p && (l.scrollTop = l.scrollHeight - c);
                  D(d.value, i.parentEl) && i.emit();

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      complete: function complete() {
        r.value = "complete", t == null || t.disconnect();
      },
      error: function error() {
        r.value = "error";
      }
    };

    return b(k, function () {
      t == null || t.disconnect(), t = y(i);
    }), N( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return q(L);

            case 2:
              i.parentEl = _context2.sent;
              t = y(i);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))), O(function () {
      t == null || t.disconnect();
    }), function (l, _) {
      return E(), w("div", {
        ref_key: "infiniteLoading",
        ref: d,
        style: {
          "min-height": "1px"
        }
      }, [V(s("div", null, [u(l.$slots, "spinner", {}, function () {
        return [M(G)];
      }, !0)], 512), [[T, r.value == "loading"]]), r.value == "complete" ? u(l.$slots, "complete", {
        key: 0
      }, function () {
        var a;
        return [s("span", null, v(((a = l.slots) == null ? void 0 : a.complete) || "No more results!"), 1)];
      }, !0) : g("", !0), r.value == "error" ? u(l.$slots, "error", {
        key: 1,
        retry: i.emit
      }, function () {
        var a;
        return [s("span", J, [s("span", null, v(((a = l.slots) == null ? void 0 : a.error) || "Oops something went wrong!"), 1), s("button", {
          class: "retry",
          onClick: _[0] || (_[0] = //@ts-ignore
          function () {
            return i.emit && i.emit.apply(i, arguments);
          })
        }, "retry")])];
      }, !0) : g("", !0)], 512);
    };
  }
});
var W = /* @__PURE__ */x(K, [["__scopeId", "data-v-a7077831"]]);
export { W as default };